/**
 * Full-page access-denied screen (operator role gate failure).
 *
 * Rendered when GET /v1/admin/me answers 401/403: the signed-in Clerk user is
 * not an operator (no admin/support role on their Clerk publicMetadata
 * admin_role claim). The screen explains the prerequisite and offers a
 * sign-out. It never reveals backend internals.
 */
import { useClerk } from '@clerk/clerk-react';
import { Button } from '@/components/ui/button';
import { ShieldAlert, LogOut } from '@/components/icons';

export function AccessDenied() {
  const { signOut } = useClerk();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div
        role="alert"
        className="w-full max-w-md rounded-lg border bg-surface p-6 shadow-sm text-center"
      >
        <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-destructive/10 text-destructive">
          <ShieldAlert className="h-5 w-5" aria-hidden="true" />
        </div>
        <h1 className="mt-4 text-lg font-semibold text-foreground">Access denied</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Your SignupRisk account does not have the <strong>admin</strong> or{' '}
          <strong>support</strong> operator role, so the admin console is not available for this
          session.
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          Operator roles are granted internally via Clerk publicMetadata and enforced server-side.
          If you believe you should have access, contact the platform team.
        </p>
        <Button
          variant="outline"
          className="mt-6"
          onClick={() => {
            void signOut({ redirectUrl: '/sign-in' });
          }}
        >
          <LogOut aria-hidden="true" />
          Sign out
        </Button>
      </div>
    </div>
  );
}
